module.exports = __webpack_public_path__ + "static/media/thresh.9209199d.png";